import { httpDelete, httpGet, httpPost, httpPut } from '../../../global/http-utils';

import { returnResponseIfOkOrSetGlobalErrorMessage } from '../../../global/api-utils';

export const getActiveWorkflowsWithTenantResource = ({ tenantId, resourceId }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/${tenantId}/workflows/syncTenantWorkflows/${resourceId}`),
    `Failed to retrieve workflows`
  );
};

export const getTenantMachineTranslationResources = ({ tenantId, awsAccountId = null }) => {
  const params = { awsAccountId: awsAccountId };
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/tenants/${tenantId}/tenant-resources/machine-translation-resources`, undefined, params),
    `Failed to retrieve machine translation resources`
  );
};

export const addTenantMachineTranslationResource = ({ tenantId, resource }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () =>
      httpPost(`tsi-multit/tenants/${tenantId}/tenant-resources/machine-translation-resources`, {
        newResource: resource,
      }),
    'Failed to add a new machine translation resource'
  );
};

export const updateTenantMachineTranslationResource = ({ tenantId, resource }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () =>
      httpPut(`tsi-multit/tenants/${tenantId}/tenant-resources/machine-translation-resources/${resource.uuid}`, {
        updatedResource: resource,
      }),
    'Failed to update machine translation resource'
  );
};

export const removeTenantMachineTranslationResource = ({ tenantId, resourceId }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpDelete(`tsi-multit/tenants/${tenantId}/tenant-resources/machine-translation-resources/${resourceId}`, {}),
    `Failed to delete machine translation resource`
  );
};

export const getTenantTranslationMemoryResources = ({ tenantId, awsAccountId = null }) => {
  const params = { awsAccountId: awsAccountId };
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/tenants/${tenantId}/tenant-resources/translation-memory-resources`, undefined, params),
    `Failed to retrieve translation memory resources`
  );
};

export const addTenantTranslationMemoryResource = ({ tenantId, resource }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () =>
      httpPost(`tsi-multit/tenants/${tenantId}/tenant-resources/translation-memory-resources`, {
        newResource: resource,
      }),
    'Failed to add a new translation memory resource'
  );
};

export const updateTenantTranslationMemoryResource = ({ tenantId, resource }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () =>
      httpPut(`tsi-multit/tenants/${tenantId}/tenant-resources/translation-memory-resources/${resource.uuid}`, {
        updatedResource: resource,
      }),
    'Failed to update translation memory resource'
  );
};

export const removeTenantTranslationMemoryResource = ({ tenantId, resourceId }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpDelete(`tsi-multit/tenants/${tenantId}/tenant-resources/translation-memory-resources/${resourceId}`, {}),
    'Failed to delete translation memory resource'
  );
};

export const getTenantTerminologyBaseResources = ({ tenantId, awsAccountId = null }) => {
  const params = { awsAccountId: awsAccountId };
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/tenants/${tenantId}/tenant-resources/terminology-base-resources`, undefined, params),
    `Failed to retrieve terminology base resources`
  );
};

export const addTenantTerminologyBaseResource = ({ tenantId, resource }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () =>
      httpPost(`tsi-multit/tenants/${tenantId}/tenant-resources/terminology-base-resources`, {
        newResource: resource,
      }),
    'Failed to add a new terminology base resource'
  );
};

export const updateTenantTerminologyBaseResource = ({ tenantId, resource }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () =>
      httpPut(`tsi-multit/tenants/${tenantId}/tenant-resources/terminology-base-resources/${resource.uuid}`, {
        updatedResource: resource,
      }),
    'Failed to update terminology base resource'
  );
};

export const removeTenantTerminologyBaseResource = ({ tenantId, resourceId }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpDelete(`tsi-multit/tenants/${tenantId}/tenant-resources/terminology-base-resources/${resourceId}`, {}),
    'Failed to delete terminology base resource'
  );
};

export const getTenantAwsAccountResource = ({ tenantId }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/tenants/${tenantId}/tenant-resources/aws-accounts`),
    `Failed to retrieve Aws account resources`
  );
};

export const addTenantAwsAccountResource = ({ tenantId, resource }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () =>
      httpPost(`tsi-multit/tenants/${tenantId}/tenant-resources/aws-accounts`, {
        newResource: resource,
      }),
    'Failed to add a new Aws account resources'
  );
};

//TODO Remove since we do not allow edit aws account.
export const updateTenantAwsAccountResource = ({ tenantId, resource }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () =>
      httpPut(`tsi-multit/tenants/${tenantId}/tenant-resources/aws-accounts/${resource.uuid}`, {
        updatedResource: resource,
      }),
    'Failed to update terminology base resource'
  );
};

export const removeTenantAwsAccountResource = ({ tenantId, resourceId }) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpDelete(`tsi-multit/tenants/${tenantId}/tenant-resources/aws-accounts/${resourceId}`, {}),
    `Failed to delete Aws account resources`
  );
};
